export default {
    title: 'EMPRESAS DE TRANSPORTE ADHERIDAS',
    subtitle: 'Para más información haga click en los nombres de las empresas',
    filter: 'Filtrar empresas por:',
    all: 'Todos los países',
}